import { EMPTY_OBJECT } from '../../../../constants/common'
import { ControlTime } from '../ControlTime'

import { control } from './control'

/**
 * @param {string} name
 * @param {TimeLike} value
 * @param {Object} defaultProps
 */
export function time(name, value, defaultProps = EMPTY_OBJECT) {
  return control(name, value, ControlTime, defaultProps)
}
